import { render, staticRenderFns } from "./index.vue?vue&type=template&id=647eb2fb&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=647eb2fb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647eb2fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('647eb2fb')) {
      api.createRecord('647eb2fb', component.options)
    } else {
      api.reload('647eb2fb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=647eb2fb&scoped=true&lang=pug", function () {
      api.rerender('647eb2fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/class/vipClassroom/academyTalksEnterClassroom/index.vue"
export default component.exports